export default {
  styleOverrides: {
    root: {
      boxShadow: "0px 6px 14px #EDEDED",
      borderRadius: "10px !important",
    },
  },
};
